import Authenticated from "@/Layouts/Authenticated";
import { useForm, usePage } from "@inertiajs/inertia-react";
import PageHeading from "@/Components/PageHeading";
import LoadingButton from "@/Components/LoadingButton";
import Label from "@/Components/Label";
import SmsTextArea from "@/Components/SmsTextArea";
import { Inertia } from "@inertiajs/inertia";

const Create = () => {
    const breadcrumb = [
        { name: "Dashboard", route: route("dashboard") },
        { name: "Settings", route: null },
        { name: "SMS Template Config", route: null },
    ];
    const { sms_configs } = usePage().props;

    const { data, setData, errors, processing, post } = useForm({
        ALERT_SMS_TEMPLATE: sms_configs.ALERT_SMS_TEMPLATE || "",
    });

    function handleCancel(e) {
        e.preventDefault();
        Inertia.visit(route("settings.sms.config"));
    }

    function handleSubmit(e) {
        e.preventDefault();
        post(route("settings.sms.config"));
    }
    return (
        <div className="py-6">
            <PageHeading
                heading={"SMS Configurations"}
                breadcrumb={breadcrumb}
            />
            <div className="mt-8">
                <div className="mx-auto max-w-lg px-4 py-10 pb-12 lg:pb-16">
                    <form onSubmit={handleSubmit}>
                        <div className="space-y-6">
                            <div>
                                <Label
                                    label={"Fee Alert SMS Template"}
                                    name={"alertSmsTemplate"}
                                />
                                <SmsTextArea
                                    id={"alertSmsTemplate"}
                                    name={"alertSmsTemplate"}
                                    onChange={(e) =>
                                        setData(
                                            "ALERT_SMS_TEMPLATE",
                                            e.target.value
                                        )
                                    }
                                    errors={errors.ALERT_SMS_TEMPLATE}
                                    value={data.ALERT_SMS_TEMPLATE}
                                />
                            </div>
                        </div>
                        <div className="pt-5">
                            <div className="flex justify-end space-x-1">
                                <LoadingButton
                                    type={"button"}
                                    onClick={handleCancel}
                                    loading={processing}
                                    className={"btn-secondary"}
                                >
                                    Cancel
                                </LoadingButton>
                                <LoadingButton
                                    type={"submit"}
                                    loading={processing}
                                    className={"btn-primary"}
                                >
                                    Update
                                </LoadingButton>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

Create.layout = (page) => (
    <Authenticated title={"Sms Config"} children={page} />
);

export default Create;
